import { FT } from 'ft'
import { Sprite, Text, TextStyle } from 'pixi.js'
import store from '#/store'

const { rm } = FT

const $title = 'bed-title'
const $box = 'bed-box'
const $rules = 'bed-rules'
const $prizes = 'bed-prizes'

FT.rm.addImage($title)
FT.rm.addImage($box)
FT.rm.addImage($rules)
FT.rm.addImage($prizes)

const normalStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 30,
  fill: '#d7682c',
})

class Rule extends Sprite {
  constructor({ heroId, temp }) {
    super(FT.rm.texture($rules))
    this.anchor.set(0.5, 0)

    const heroNames = {
      yi: '易',
      md: '蒙多',
      neeko: '妮蔻',
      akl: '阿卡丽',
      ls: '图奇',
      slk: '索拉卡',
    }

    const chineseName = heroNames[heroId]
    const name = new Text(chineseName, normalStyle)
    name.x = -175
    name.y = 104
    this.addChild(name)

    const $temp = new Text(`${temp}°C`, normalStyle)
    $temp.anchor.set(0.5)
    $temp.x = 50
    $temp.y = 50
    this.addChild($temp)
  }
}

const closeStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 42,
  fill: '#99462c',
})

class RuleBox extends Sprite {
  constructor(onClose) {
    super(FT.rm.texture($box))

    this.interactive = true
    this.anchor.set(0.5, 0.5)
    this.x = FT.stage.centerX
    this.y = FT.stage.centerY - 100

    const close = new Text('X', closeStyle)
    close.anchor.set(0.5)
    close.x = 255
    close.y = -410
    close.interactive = true
    close.on('pointerup', () => {
      onClose()
    })
    this.addChild(close)

    const title = new Sprite(rm.texture($title))
    title.anchor.set(0.5)
    title.y = -390
    this.addChild(title)

    const rule = new Rule({ heroId: store.hero, temp: store.temp })
    rule.y = -350
    this.addChild(rule)

    const prizes = new Sprite(rm.texture($prizes))
    prizes.anchor.set(0.5, 0)
    prizes.y = -25
    this.addChild(prizes)
  }

  gotoPorchScene = () => {
    FT.sm.load('porch', { transition: true })
  }
}

export default RuleBox
